// extracted by mini-css-extract-plugin
export default {"container":"Pu-z","title":"Qu-z","linkContainer":"Ru-z","viewItemLink":"Su-z"};